
import { Flight } from '@/types/flight';
import { FlightSearchFilters, FlightSearchCriteria } from './FlightSearchFilters';
import { SearchResultsTable } from './SearchResultsTable';
import { useFlightSearch } from './useFlightSearch';

interface FlightSearchSectionProps {
  onSelectFlight: (flight: Flight) => void;
}

export function FlightSearchSection({ onSelectFlight }: FlightSearchSectionProps) {
  const { searchResults, isSearching, hasSearched, searchFlights, clearSearch } = useFlightSearch();

  const handleSearch = (criteria: FlightSearchCriteria) => {
    searchFlights(criteria);
  };

  const handleClear = () => {
    clearSearch();
  };

  const handleSelectFlight = (flight: Flight) => {
    onSelectFlight(flight);
  };

  return (
    <div className="space-y-6">
      <FlightSearchFilters
        onSearch={handleSearch}
        onClear={handleClear}
        isSearching={isSearching}
      />
      
      {hasSearched && (
        <SearchResultsTable
          flights={searchResults}
          onSelectFlight={handleSelectFlight}
          loading={isSearching}
        />
      )}
    </div>
  );
}
